import I18n from 'I18n';
import * as FileValidationErrors from '../enums/FileValidationErrors';
import getDoesStringOnlyContainSpaces from './getDoesStringOnlyContainSpaces';
export default function validateFileName(fileName) {
  if (getDoesStringOnlyContainSpaces(fileName)) {
    return {
      code: FileValidationErrors.ONLY_WHITESPACES,
      message: I18n.text('FileManagerCore.fileNameValidation.invalidNameOnlyWhitespace')
    };
  }
  if (fileName.length > 255) {
    return {
      code: FileValidationErrors.FILE_NAME_TOO_LONG,
      message: I18n.text('FileManagerCore.fileNameValidation.fileNameTooLong')
    };
  }
  return null;
}